/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import jwt from "../../http/requests/auth/jwt/index.js";
import axios from "@/axios.js";
import router from "@/router";
export default {
  // JWT
  loginJWT({ commit }, payload) {
    debugger;
    return new Promise((resolve, reject) => {
      debugger;
      jwt
        .login(payload.userDetails.userName, payload.userDetails.password)
        .then((response) => {
          // If there's user data in response
          if (response.data.data) {
            debugger;

            // Set token
            debugger;
            localStorage.setItem("token", response.data.data.Token);
            localStorage.setItem("Token", response.data.data.Token);
            localStorage.setItem(
              "RefreshToken",
              response.data.data.RefreshToken
            );

            // Update user details
            commit("UPDATE_USER_INFO", response.data.data, {
              root: true,
            });

            // Set bearer token in axios
            commit("SET_BEARER", response.data.data.Token);
            //slocalStorage.setItem("TypeOfLogin", payload.TypeOfLogin)
            // to call local sotrage
            //localStorage.getItem('TypeOfLogin')
            resolve(response);
          } else {
            reject({ message: "Wrong Email or Password" });
          }
        })
        .catch((error) => {
          //debugger;
          reject(error);
        });
    });
  },

  ChangeUserLanguage({ commit }, languageId) {
    return new Promise((resolve, reject) => {
      debugger;
      jwt
        .ChangeUserLanguage(languageId)
        .then((response) => {
          if (response.data.data) {
            debugger;
            localStorage.setItem("token", response.data.data.Token);
            // localStorage.setItem("expiresIn", response.data.data.expiresIn);
            localStorage.setItem("accessToken", response.data.data.Token);
            localStorage.setItem(
              "RefreshToken",
              response.data.data.RefreshToken
            );
            commit("UPDATE_USER_INFO", response.data.data, {
              root: true,
            });
            commit("SET_BEARER", response.data.data.Token);
            resolve(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  Register({ commit }, model) {
    debugger
    return new Promise((resolve, reject) => {
      axios
        .post("/register", model)
        .then((response) => {
          debugger;
          localStorage.setItem("Token", response.data.data.Token);
          // localStorage.setItem("expiresIn", response.data.data.expiresIn);
          localStorage.setItem("RefreshToken", response.data.data.RefreshToken);

          // Update user details
          commit("UPDATE_USER_INFO", response.data.data, {
            root: true,
          });

          // Set bearer token in axios
          commit("SET_BEARER", response.data.data.Token);
          resolve(response);
        })
        .catch((error) => {
          debugger
          reject(error);
        });
      debugger
    });
  },

  fetchAccessToken() {
    //debugger;
    return new Promise((resolve) => {
      jwt
        .RefreshToken()
        .then((response) => {
          resolve(response);
        })
        .catch(function () {
          //debugger;
          //router.push("/pages/login");
        });
    });
  },
  
  logout({ commit }) {
    // Set Token
    localStorage.removeItem("Token");
    localStorage.removeItem("RefreshToken");
    localStorage.removeItem("expiresIn");
    // Update user details
    commit("CLEAR_USER_INFO", null, { root: true });
    // Set bearer token in axios
    commit("REMOVE_BEARER");
    router.push("/login");
  },
  EditProfile({ commit }, model) {
    return new Promise((resolve, reject) => {
      debugger;
      axios
        .post("/Account/EditProfile", model)
        .then((response) => {
          if (response.data.data) {
            debugger;
            console.log(response);

            // Update user details
            commit("UPDATE_USER_INFO", response.data.data, {
              root: true,
            });

            // Set bearer token in axios
            commit("SET_BEARER", response.data.data.Token);
          }
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  ChangePassword(context, model) {
    return new Promise((resolve, reject) => {
      debugger;
      axios
        .post("/Account/ChangePassword", model)
        .then((response) => {
          debugger;
          console.log(response);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  SocialLogin({ commit }, model) {
    return new Promise((resolve, reject) => {
      debugger;
      axios
        .post("/API/Account/socialLogin", model)
        .then((response) => {
          localStorage.setItem("Token", response.data.data.Token);
          // localStorage.setItem("expiresIn", response.data.data.expiresIn);
          localStorage.setItem("RefreshToken", response.data.data.RefreshToken);

          // Update user details
          commit("UPDATE_USER_INFO", response.data.data, {
            root: true,
          });

          // Set bearer token in axios
          commit("SET_BEARER", response.data.data.Token);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  SetActivityLog(context, model) {
    var Model = {
      audioID: model,
    };
    return new Promise((resolve, reject) => {
      debugger;
      axios.post("/API/ActivityLog/SetActivityLog", Model);
    });
  },
};
